import { Api } from '@coder-house/ch-coder-util'

import { INotification } from '../models/notification.interface'
import { Notification } from '../models/notification.model'

import { isAuthenticated } from './session'

const { VUE_APP_CH_API_BFF } = process.env

async function getNotifications() {
  await isAuthenticated()
  const notifications = await Api.get<INotification[]>(`${VUE_APP_CH_API_BFF}/v1/home/notifications`)

  return notifications.map(notification => new Notification(notification))
}

async function readNotifications(notificationId: string, isCoderV3: boolean = false) {
  await isAuthenticated()
  try {
    const response = await Api.put<any>(
      `${VUE_APP_CH_API_BFF}/v1/home/notifications/${notificationId}/readed?is_coder_v3=${isCoderV3}`,
      {}
    )
  
    return response
  } catch (error) {
    console.error(error.message)
    return null
  }
}

export { getNotifications, readNotifications }
